import React, { useEffect } from "react"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData, useCsv } from "Pages/ReportsAlerts/Reports/@signals"
import { object, string } from "yup"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"
import { BACKEND_APIS } from "@constants"
import { isEmpty } from "@ui-seeker/utils"


export default function TimeToSelector() {

	const {
		timeTo,
		setTimeToInfo,
		error
	} = useReportFormInfo(reportFormData.peek().timeTo, "timeTo", object({ timeTo: string().required("Must provide a end hour") }))

	useEffect(() => {
		if (!timeTo && !isEmpty(reportFormData.value)) setTimeToInfo("10:00")
	}, [timeTo])

	useEffect(() => {
		return () => {
			if (!isEmpty(reportFormData.value)) setTimeToInfo("10:00", false)
		}
	}, [useCsv.value])

	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		label="Dropoff Time"
		placeholder="Dropoff Time"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/report/options/hours`}
		value={timeTo}
		onChange={e => setTimeToInfo(e.target.value)}
		error={error}
	/>
}

